import { render, staticRenderFns } from "./MenuPurchase.vue?vue&type=template&id=45bfae66&"
import script from "./MenuPurchase.vue?vue&type=script&lang=js&"
export * from "./MenuPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports